'use client';

import React from 'react';
import {
    DevPanel,
    DEV_PANEL_TEST_IDS,
    type IDevPanelMockField,
    type IDevPanelStorage,
} from '@web-store-platforms/dev-tools';
import { ELocalStorageKeys } from '@web-store-platforms/types';
import { webStorageUtil } from '@/lib/storage/webStorageUtil';
import { syncDevApiMockCookie } from '@/lib/dev/api-mock.utils';
import { TemplateIdOverrideField } from './TemplateIdOverrideField';

interface IStoreDevPanelProps {
    onClose: () => void;
}

const STORE_DEV_PANEL_FIELDS: ReadonlyArray<IDevPanelMockField> = [
    {
        id: 'offers',
        label: 'Override GET Offer API',
        storageKey: ELocalStorageKeys.MOCK_OFFERS_API,
        testId: DEV_PANEL_TEST_IDS.offers,
    },
    {
        id: 'boot',
        label: 'Override GET Boot API',
        storageKey: ELocalStorageKeys.MOCK_BOOT_API,
        testId: DEV_PANEL_TEST_IDS.boot,
    },
    {
        id: 'template',
        label: 'Override GET Template API',
        storageKey: ELocalStorageKeys.MOCK_TEMPLATE_API,
        testId: DEV_PANEL_TEST_IDS.template,
    },
];

const storeDevPanelStorage: IDevPanelStorage = {
    get: (key: string): unknown => webStorageUtil.get(key as ELocalStorageKeys),
    set: (key: string, value: unknown): void => {
        webStorageUtil.set(key as ELocalStorageKeys, value);
    },
    remove: (key: string): void => {
        webStorageUtil.remove(key as ELocalStorageKeys);
    },
};

const persistAndReload = (): void => {
    syncDevApiMockCookie();
    window.location.reload();
};

export const StoreDevPanel = ({ onClose }: IStoreDevPanelProps): React.ReactElement => (
    <DevPanel
        onClose={onClose}
        fields={STORE_DEV_PANEL_FIELDS}
        storage={storeDevPanelStorage}
        onAfterSave={persistAndReload}
        onAfterClear={persistAndReload}
        beforeMockFields={<TemplateIdOverrideField />}
    />
);
